import { Link } from "react-router-dom";
import { ArrowRight, Leaf } from "lucide-react";
import { IMG, WHATSAPP_PRODUCT_LINK } from "@/data/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const ZoryvenHero = () => (
  <section className="relative overflow-hidden zv-grain" data-testid="zoryven-hero-section">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute -top-40 -left-40 w-[36rem] h-[36rem] rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -bottom-40 right-0 w-[30rem] h-[30rem] rounded-full bg-[#D48C46]/10 blur-3xl" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 dir3-animate">
          <div className="inline-flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#D48C46]" />
            <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.25em] text-[#E5A862]">Herbal hair wellness from Lolab Valley</span>
          </div>
          <h1 className="font-condensed text-6xl sm:text-8xl lg:text-[9rem] uppercase tracking-tight text-white leading-[0.85]" data-testid="zoryven-h1">
            ZORYVEN
          </h1>
          <p className="mt-6 text-lg sm:text-2xl text-emerald-100 font-medium" data-testid="zoryven-subheading">Zoryven Hair Care and Fancy Saloon</p>
          <p className="mt-3 text-base sm:text-lg text-slate-300 font-light leading-relaxed max-w-xl">
            Where hair care meets hair wellness. Salon-born herbal formulations for hair fall, dry scalps and tired strands — made by the stylists of Fancy Saloon, Sogam.
          </p>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 mt-10">
            <a href="#range" data-testid="zoryven-hero-products-btn" className="px-8 py-4 bg-[#D48C46] hover:bg-[#E5A862] text-slate-950 font-bold uppercase tracking-wider text-xs rounded-xl text-center transition-colors shadow-lg shadow-[#D48C46]/20">
              Explore the Range
            </a>
            <Link to="/saloon" data-testid="zoryven-hero-saloon-btn" className="px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 text-slate-100 font-semibold uppercase tracking-wider text-xs rounded-xl text-center transition-colors inline-flex items-center justify-center gap-2">
              Visit Fancy Saloon <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={WHATSAPP_PRODUCT_LINK} target="_blank" rel="noreferrer" data-testid="zoryven-hero-whatsapp-btn" className="px-6 py-4 text-[#25D366] hover:text-emerald-300 font-semibold uppercase tracking-wider text-xs inline-flex items-center justify-center gap-2 transition-colors">
              <WhatsAppIcon className="w-4 h-4" /> WhatsApp
            </a>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden border border-emerald-900/60 shadow-2xl shadow-black/60 bg-[#0B1E16] flex items-center justify-center" data-testid="zoryven-hero-logo">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(212,140,70,0.18),transparent_55%)]" />
            {IMG.logo ? (
              <img src={IMG.logo} alt="Zoryven Hair Care logo" className="relative w-4/5 max-h-[70%] object-contain" data-testid="zoryven-logo-image" />
            ) : (
              <div className="relative text-center px-8">
                <div className="mx-auto w-24 h-24 rounded-full border-2 border-[#D48C46] flex items-center justify-center">
                  <Leaf className="w-12 h-12 text-emerald-300" />
                </div>
                <div className="font-condensed text-5xl sm:text-6xl uppercase text-white mt-6 leading-none">Zoryven</div>
                <div className="text-sm sm:text-base uppercase tracking-[0.45em] text-[#E5A862] mt-3">Hair Care</div>
                <div className="mx-auto mt-6 h-px w-20 bg-[#D48C46]/60" />
              </div>
            )}
            <div className="absolute bottom-5 left-5 right-5 p-4 rounded-2xl bg-[#06140E]/80 border border-emerald-900/60 backdrop-blur text-center">
              <span className="text-[11px] font-bold text-[#E5A862] uppercase tracking-wider">Zoryven Hair Care</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);
